// mui 5
import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardMedia from "@mui/material/CardMedia";
import Box from "@mui/system/Box";

const flexColumnCenter = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
};

export const StyledCardContainer = styled(Card)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  width: "100%",
  minWidth: "340px",
  height: "200px",
  borderRadius: "20px",
  backgroundColor: "#232323",

  transform: "scale(1, 1)",

  transition: "transform .5s ease",
  "&:hover": {
    transform: "scale(1.05,1.05)",
  },
}));

export const StyledCardMedia = styled(CardMedia)(({ theme }) => ({
  objectFit: "none",
  minWidth: "100px",
  width: "100%",
}));

export const StyledCardContent = styled(Box)(({ theme }) => ({
  ...flexColumnCenter,
  width: "100%",
}));

export const StyledCardHeader = styled(CardHeader)(({ theme }) => ({
  "& .MuiCardHeader-subheader": {
    color: "#ccc",
    fontSize: theme.spacing(2),
  },
  "& .MuiCardHeader-title": {
    color: "#eee",
    fontSize: theme.spacing(3),
  },
}));

export const StyledQuantityControl = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-around",
  alignItems: "center",
}));

export const StyledCardActions = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginBottom: theme.spacing(2),
}));
